import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@driftt/tide'
import { formatStatusText } from '../../helpers'
import { articleStatus } from 'modules/knowledgebase/model'
import cx from 'classnames'
import moment from 'moment'

import EditCategoryIcon from 'images/edit_category_icon.svg'
import DeleteCategoryIcon from 'images/delete_category_icon.svg'
import ArticleFeedbackReport from './ArticleFeedbackReport'

import './style.css'


const RowFormatter = {
  ArticleTableRows: (article, onDeleteArticleClick) => {
    return {
    	data: [
				{
					content: (<Icon name="hamburger"/>)
				},
				{content: (
					<Link
						className="category-article-name"
						to={`/article/${article.slug}`}
					>
						{article.title}
					</Link>
				)},
				{content: (
					<span
						className={cx({
							'category-article-status-private': article.status === articleStatus.PRIVATE,
							'category-article-status-draft': article.status === articleStatus.DRAFT,
							'category-article-status-publish': article.status === articleStatus.PUBLISHED
						})}
					>
						{formatStatusText(article.status)}
					</span>
				)},
				{content: (
					<span className="article-created-date">
						{moment(article.createdAt).format('M/DD/YYYY')}
					</span>
				)},
				{content: (
					<span className="article-updated-date">
						{moment(article.updatedAt).format('M/DD/YYYY')}
					</span>
				)},
				{content: (
					<ArticleFeedbackReport article={article} feedbackType="upvote"/>
				)},
				{content: (
					<ArticleFeedbackReport article={article} feedbackType="downvote"/>
				)},
				{content: (
					<Link to={`/article/${article.slug}`}>
						<img className="category-section-card-edit-icon" src={EditCategoryIcon} alt="Edit Article"/>
					</Link>
				)},
				{
					content: <img onClick={onDeleteArticleClick(article)} className="category-section-article-delete-icon" src={DeleteCategoryIcon} alt="Delete Article"/>
				}
  	]}},
  SearchTableRows: (article, onDeleteArticleClick) => {
    return {
      data: [
        {
        	content: (
					<Link
						className="category-article-name"
						to={`/article/${article.slug}`}
					>
						{article.title}
					</Link>
				)},
        {
        	content: (
					<span
						className={cx({
							'category-article-status-private': article.status === articleStatus.PRIVATE,
							'category-article-status-draft': article.status === articleStatus.DRAFT,
							'category-article-status-publish': article.status === articleStatus.PUBLISHED
						})}
					>
						{formatStatusText(article.status)}
					</span>
				)},
        {
        	content: (
					<span className="article-created-date">
					  {moment(article.createdAt).format('M/DD/YYYY')}
					</span>
				)},
        {
        	content: (
					<span className="article-updated-date">
						{moment(article.updatedAt).format('M/DD/YYYY')}
					</span>
				)},
        {
        	content: (
					<ArticleFeedbackReport article={article} feedbackType="upvote"/>
				)},
        {content: (
					<ArticleFeedbackReport article={article} feedbackType="downvote"/>
				)},
        {
        	content: (
					<Link to={`/article/${article.slug}`}>
						<img className="category-section-card-edit-icon" src={EditCategoryIcon} alt="Edit Article"/>
					</Link>
				)},
        {
          content: <img onClick={onDeleteArticleClick(article)} className="category-section-article-delete-icon" src={DeleteCategoryIcon} alt="Delete Article"/>
        }
      ]}}
}

export default RowFormatter